import React from 'react';
import { contactContent } from '@/content/contact';
import { Icon, Reveal } from '@/components/ui';

const ContactDetails: React.FC = () => {
    return (
        <Reveal as="div" className="contact-details-box card">
            <h3>{contactContent.details.heading}</h3>
            <div className="info-list">
                {contactContent.details.channels.map((channel) => (
                    <div className="info-item" key={channel.label}>
                        <Icon name={channel.icon} />
                        <div>
                            <strong>{channel.label}</strong>
                            <p>{channel.value}</p>
                        </div>
                    </div>
                ))}
            </div>
        </Reveal>
    );
};

export default ContactDetails;
